export const FUNCTIONALITY_NOT_ENABLED_URL = "functionalityNotEnabled";
export const INLINE_DONATION_URLS = {
    donate: "donationDonate",
    card: "donationCard",
    address: "donationAddress",
    thankYou: "donationThankYou",
    failed: "donationFailed",
};
export const INLINE_EDIT_DONATION_URLS = {
    donate: "editDonationDonate",
    card: "editDonationCard",
    thankYou: "editDonationThankYou",
    cancel: "editDonationCancel",
    cancelSuccess: "editDonationCancelSuccess",
};
export const INLINE_SUBSCRIPTION_URLS = {
    subscriptionsOverview: "subscriptionsOverview",
    paymentDetails: "paymentDetails",
    subscriptionCheckout: "subscriptionCheckout",
    subscribeThankYou: "subscribeThankYou",
    subscribeFailed: "subscribeFailed",
    address: "subscribeAddress",
};
export const INLINE_EDIT_SUBSCRIPTION_URLS = {
    subscribe: "editSubscriptionSubscribe",
    changePlan: "editSubscriptionChangePlan",
    paymentDetails: "editSubscriptionPaymentDetails",
    cancel: "editSubscriptionCancel",
    cancelSuccess: "editSubscriptionCancelSuccess",
    success: "editSubscriptionSuccess",
    address: "editSubscriptionAddress",
};
export const INLINE_NEWSLETTER_URLS = {
    subscribe: "newsletterSubscribe",
    success: "newsletterSuccess",
};
export const INLINE_USER_DASHBOARD_URLS = {
    removeCard: "dashboardRemoveCard",
    cardInUsage: "dashboardCardInUsage",
    addPublicCard: "dashboardAddPublicCard",
    addAddress: "dashboardAddAddress",
    editAddress: "dashboardEditAddress",
    addressInUsage: "dashboardAddressInUsage",
    removeAddress: "dashboardRemoveAddress",
    editPersonalDetails: "dashboardEditPersonalDetails",
    confirmEmailChange: "dashboardConfirmEmailChange",
    editSubscriptionPaymentMethod: "dashboardEditSubscriptionPaymentMethod",
    editSubscriptionAddress: "dashboardEditSubscriptionAddress",
    editSubscriptionPlan: "dashboardEditSubscriptionPlan",
    subscriptionChangeConfirm: "dashboardSubscriptionChangeConfirm",
    subscriptionChangeSuccess: "dashboardSubscriptionChangeSuccess",
    changeEmailConfirmationCode: "dashboardChangeEmailConfirmationCode",
};
export const DONATE_PAGE_URLS = {
    donate: "donateDonate",
    payWithAddedCard: "donatePayWithAddedCard",
    payWithChosenCard: "donatePayWithChosenCard",
    auth: "donateAuth",
    confirmCode: "donateConfirmCode",
    thankYou: "donateThankYou",
    thankYouMessageReceived: "donateThankYouMessageReceived",
    editDonation: "donateEditDonation",
    recurringDonor: "donateRecurringDonor",
    editChooseCard: "donateEditChooseCard",
    donationUpdated: "donateDonationUpdated",
    editAddCard: "donateEditAddCard",
    cancelDonation: "donateCancelDonation",
    donationCanceled: "donateDonationCanceled",
    paymentFailed: "donatePaymentFailed",
};
